/**
 * Scroll reveal and the header that hides while scrolling down.
 *
 * Content is only hidden once this script has added `js-reveal` to <html>,
 * so nothing disappears if the script fails. Reduced-motion preferences and
 * the theme editor both skip the reveal entirely.
 */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- Reveal on scroll ---------- */

  var TARGETS = [
    'main .section-head',
    'main .promo__media',
    'main .promo__content',
    'main .tile',
    'main .card-product',
    'main .collections-feature',
    'main .collections-card',
    'main .collection__banner',
    'main .collections-index__head',
    'main .rich-text',
    'main .product__media-item'
  ].join(',');

  if (!reduceMotion && !designMode && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    html.classList.add('js-reveal');

    document.querySelectorAll(TARGETS).forEach(function (el) {
      // Stagger siblings in grids so a row arrives one card after another.
      var item = el.closest('li') || el;
      var siblings = item.parentElement ? Array.prototype.indexOf.call(item.parentElement.children, item) : 0;
      el.style.setProperty('--reveal-delay', Math.min(siblings % 4, 3) * 90 + 'ms');
      el.classList.add('reveal');
      observer.observe(el);
    });
  }

  /* ---------- Header: hide on scroll down, show on scroll up ---------- */

  var header = document.querySelector('.header-section');
  if (!header) return;

  var lastY = window.scrollY;

  function update() {
    var y = window.scrollY;
    var height = header.offsetHeight;
    var menuOpen = header.querySelector('details[open]');

    header.classList.toggle('header-section--scrolled', y > 4);

    if (menuOpen || y < height) {
      header.classList.remove('header-section--hidden');
    } else if (y > lastY + 4) {
      header.classList.add('header-section--hidden');
    } else if (y < lastY - 4) {
      header.classList.remove('header-section--hidden');
    }
    lastY = y;
  }

  // Only reads scroll position and toggles classes, so it is cheap enough to
  // run on every scroll event.
  window.addEventListener('scroll', update, { passive: true });

  // Keyboard users tabbing into the header always get it back.
  header.addEventListener('focusin', function () {
    header.classList.remove('header-section--hidden');
  });

  /* ---------- Desktop dropdowns open on hover ---------- */

  var desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');
  header.querySelectorAll('.header__dropdown').forEach(function (details) {
    var timer;
    details.addEventListener('mouseenter', function () {
      if (!desktop.matches) return;
      window.clearTimeout(timer);
      details.setAttribute('open', '');
    });
    details.addEventListener('mouseleave', function () {
      if (!desktop.matches) return;
      timer = window.setTimeout(function () { details.removeAttribute('open'); }, 140);
    });
  });
})();
